// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminPostFormController from "./admin_post_form_controller"
application.register("admin-post-form", AdminPostFormController)

import AdminTrackNumbersController from "./admin_track_numbers_controller"
application.register("admin-track-numbers", AdminTrackNumbersController)

import AdminYuBabyMessageController from "./admin_yu_baby_message_controller"
application.register("admin-yu-baby-message", AdminYuBabyMessageController)

import AutoModalController from "./auto_modal_controller"
application.register("auto-modal", AutoModalController)

import BodyController from "./body_controller"
application.register("body", BodyController)

import CopyTextController from "./copy_text_controller"
application.register("copy-text", CopyTextController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import DynamicTextareaController from "./dynamic_textarea_controller"
application.register("dynamic-textarea", DynamicTextareaController)

import IconCropperController from "./icon_cropper_controller"
application.register("icon-cropper", IconCropperController)

import PickupController from "./pickup_controller"
application.register("pickup", PickupController)

import PlayerController from "./player_controller"
application.register("player", PlayerController)

import SlickController from "./slick_controller"
application.register("slick", SlickController)

import TabUniqueIdController from "./tab_unique_id_controller"
application.register("tab-unique-id", TabUniqueIdController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TrackController from "./track_controller"
application.register("track", TrackController)

import WhatsNewModalController from "./whats_new_modal_controller"
application.register("whats-new-modal", WhatsNewModalController)

import YoutubeFormController from "./youtube_form_controller"
application.register("youtube-form", YoutubeFormController)

import YuBabyController from "./yu_baby_controller"
application.register("yu-baby", YuBabyController)

import YuBabyErrorCallbackController from "./yu_baby_error_callback_controller"
application.register("yu-baby-error-callback", YuBabyErrorCallbackController)

import YuBabyFeedbackCallbackController from "./yu_baby_feedback_callback_controller"
application.register("yu-baby-feedback-callback", YuBabyFeedbackCallbackController)

import YuBabyMessageCallbackController from "./yu_baby_message_callback_controller"
application.register("yu-baby-message-callback", YuBabyMessageCallbackController)

import YuBabyMessageController from "./yu_baby_message_controller"
application.register("yu-baby-message", YuBabyMessageController)

import YuBabyMessageLoadMoreCallbackController from "./yu_baby_message_load_more_callback_controller"
application.register("yu-baby-message-load-more-callback", YuBabyMessageLoadMoreCallbackController)

import YuBabyRateLimitController from "./yu_baby_rate_limit_controller"
application.register("yu-baby-rate-limit", YuBabyRateLimitController)
